import React from 'react';
import logo from '../../../assets/images/comunicate.png';
import './Comunicate.css';

export const Comunicate = () => (
  <div className="FooterSection">
    <a href="https://www.ciba.com.ar">
        <img alt='' src={logo} className='img_comunicate' />
    </a>
  </div>
);
